var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditLarge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.243 16H18V18H0V13.757L9.9 3.85701L14.142 8.10101L6.242 16H6.243ZM11.313 2.44401L13.435 0.322007C13.6225 0.134536 13.8768 0.0292206 14.142 0.0292206C14.4072 0.0292206 14.6615 0.134536 14.849 0.322007L17.678 3.15101C17.8655 3.33853 17.9708 3.59284 17.9708 3.85801C17.9708 4.12317 17.8655 4.37748 17.678 4.56501L15.556 6.68601L11.314 2.44401H11.313Z",
    fill: "#797F86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditLarge);
export default __webpack_public_path__ + "static/media/edit-large.8fc1d0d226e0686b93742440683f18f3.svg";
export { ForwardRef as ReactComponent };